export function getBackslashEscaped(_ref) {
  var input = _ref.input;
  return extract(input);
}
function extract(str) {
  return str.replace(/\\n/g, "");
}